import React from 'react';
import {
  Typography,
  Button,
  InputBase,
  FormControl,
  InputLabel,
} from '@mui/material';
import { Customer } from './app';
import FormControlError from '~/_base/components/formControlError';
import { useForm } from 'react-hook-form';

interface StepTwoProps {
  onNext: (data: Partial<Customer>) => void;
  formState: Partial<Customer>;
  onPrevious: () => void;
}

export default function StepTwo({
  onNext,
  onPrevious,
  formState,
}: StepTwoProps) {
  const { register, handleSubmit, formState: { errors } } = useForm();

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <Typography variant="h1" style={{ marginBottom: 24 }}>
        We need to know who you are
      </Typography>
      <FormControl
        variant="standard"
        error={errors.given_name != null}
        required
        fullWidth
        style={{ marginBottom: 16 }}>
        {errors.given_name && (
          <FormControlError
            message={
              errors.given_name.type === 'maxLength'
                ? 'Must be less than 50 characters'
                : 'First Name is required'
            }
          />
        )}
        <InputLabel htmlFor="firstName">First name</InputLabel>
        <InputBase
          id="firstName"
          autoFocus
          {...register('given_name', {
            required: true,
            validate: val => val.trim() !== '',
            maxLength: 50,
          })}
          type="text"
          data-autopilot="FirstName"
          placeholder="Your first name"
          defaultValue={formState.given_name}
        />
      </FormControl>
      <FormControl
        variant="standard"
        error={errors.surname != null}
        required
        fullWidth
        style={{ marginBottom: 16 }}>
        {errors.surname && (
          <FormControlError
            message={
              errors.surname.type === 'maxLength'
                ? 'Must be less than 50 characters'
                : 'Last Name is required'
            }
          />
        )}
        <InputLabel htmlFor="surname">Last name</InputLabel>
        <InputBase
          id="surname"
          defaultValue={formState.surname}
          {...register('surname', {
            required: true,
            validate: val => val.trim() !== '',
            maxLength: 50,
          })}
          type="text"
          data-autopilot="LastName"
          placeholder="Your last name"
        />
      </FormControl>
      <FormControl
        variant="standard"
        error={errors.telephone_number != null}
        required
        fullWidth
        style={{ marginBottom: 16 }}>
        {errors.telephone_number && (
          <FormControlError
            message={
              errors.telephone_number.type === 'maxLength'
                ? 'Must be less than 50 characters'
                : 'Phone Number is required'
            }
          />
        )}
        <InputLabel htmlFor="phoneNumber">Phone number</InputLabel>
        <InputBase
          id="phoneNumber"
          defaultValue={formState.telephone_number}
          {...register('telephone_number', {
            validate: val => val.trim() !== '',
            required: true,
            maxLength: 50,
          })}
          type="text"
          data-autopilot="Phone"
          placeholder="Your phone number"
        />
      </FormControl>
      <div
        style={{
          marginTop: 16,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button variant="contained" style={{ width: 120 }} onClick={onPrevious}>
          Previous
        </Button>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ width: 120 }}
        >
          Next
        </Button>
      </div>
    </form>
  );
}
